// extracted by mini-css-extract-plugin
export default {"socialMediaContent":"socialmedia_socialMediaContent__tohIk","socialMediaCircle":"socialmedia_socialMediaCircle__E5YL7"};